if (!customElements.get('share-links')) {
  class ShareLinks extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', () => {
        this.classList.toggle('open');
      });
    }
  }

  customElements.define('share-links', ShareLinks);
}
